import { Provider } from '@angular/core';
import { environment } from 'src/environments/environment';

import { GlobalDashboardRepository } from '@app/domain/ports/global-dashboard.repository';
import { GlobalDashboardRemoteDataSource } from '@app/data/data-sources/remote/global-dashboard-remote.data-source';
import { GlobalDashboardMockDataSource } from '@app/data/data-sources/mock/global-dashboard-mock.data-source';

/**
 * Providers del Dashboard Global ("Todo").
 *
 * `environment.globalDashboardUseMocks` decide entre datos mock (desarrollo sin
 * backend, mientras `GET /api/v1/dashboard/global-summary/` llega a stage) y el
 * data-source HTTP real. Mismo patrón que `TPV_REST_PROVIDERS`.
 */
const useMocks = environment.globalDashboardUseMocks === true;

export const GLOBAL_DASHBOARD_PROVIDERS: Provider[] = [
  {
    provide: GlobalDashboardRepository,
    useClass: useMocks ? GlobalDashboardMockDataSource : GlobalDashboardRemoteDataSource,
  },
];
